import React, { useRef, useEffect } from 'react'

import { SplitText, Power3 } from '../lib/gsap'

import { useControlledTimeline } from '../hooks/animation'
import useInView from '../hooks/useInView'

import theme from '../styles/theme'
import { media } from '../styles/tools'

const BackgroundText = props => {
  const [setInViewRef, inView] = useInView()
  const tl = useControlledTimeline({}, inView)
  const text = useRef()

  useEffect(() => {
    const { chars } = new SplitText(text.current, {
      type: 'words, chars',
    })

    tl.staggerFrom(
      chars,
      0.8,
      { opacity: 0, x: -100, ease: Power3.easeOut },
      -0.05
    )
  }, [])

  return (
    <div
      ref={ref => {
        text.current = ref
        setInViewRef(ref)
      }}
      css={{
        letterSpacing: '0.1em',
        fontSize: '14vw',
        fontFamily: 'TungstenMedium, sans-serif',
        textTransform: 'uppercase',
        color: 'rgba(255, 255, 255, .3)',
        [media.tabletMd]: {
          marginLeft: '-5.55vmax',
          color: theme.colors.black,
        },
      }}
      {...props}
    />
  )
}

export default BackgroundText
